import { render, staticRenderFns } from "./gameedit.vue?vue&type=template&id=06449e63&scoped=true"
import script from "./gameedit.vue?vue&type=script&lang=js"
export * from "./gameedit.vue?vue&type=script&lang=js"
import style0 from "./gameedit.vue?vue&type=style&index=0&id=06449e63&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06449e63",
  null
  
)

export default component.exports